import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['button', 'input'];

  connect() {
    this.validar_busqueda();
  }

  validar_busqueda() {
    const inputField = this.inputTarget;
    const submitButton = this.buttonTarget;

    const value = inputField.value.trim();
    if (value.length > 0 && value.length < 3) {
      submitButton.disabled = false;
      submitButton.style.opacity = 1;
    } else {
      submitButton.disabled = false;
      submitButton.style.opacity = 1;
    }
  }
}
